import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("fas fa-clock")

import { computed, ref, onBeforeUnmount } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'VCountdown',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as { date: Date }



const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const now = ref(new Date());

const interval = setInterval(() => {
  now.value = new Date();
}, 1000);

onBeforeUnmount(() => {
  clearInterval(interval);
});

const timeLeft = computed(() => {
  const diff = props.date.getTime() - now.value.getTime();
  const days = Math.floor(diff / DAY);
  const hours = Math.floor((diff % DAY) / HOUR);
  const minutes = Math.floor((diff % HOUR) / MINUTE);
  const seconds = Math.floor((diff % MINUTE) / SECOND);
  if (days > 0) {
    return `${days}j ${hours}h`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
  } else {
    return `${seconds}s`;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_component_v_chip, { class: "px-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, { class: "mr-2" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_unref(timeLeft)), 1)
    ]),
    _: 1
  }))
}
}

})